import axios from 'axios'

export const fetchUserCustomerInfo = () =>
  axios({
    method: 'put',
    url: '/api/user/customer',
    data: {},
  })
